import { render } from "./ViewSong.vue?vue&type=template&id=3e00759d&scoped=true"
import script from "./ViewSong.vue?vue&type=script&lang=js"
export * from "./ViewSong.vue?vue&type=script&lang=js"

import "./ViewSong.vue?vue&type=style&index=0&id=3e00759d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3e00759d"

export default script